if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              if(response.description == "Required parameter missing or invalid: id"){
                this.handleErrorMessage("Please select size");
              }else{
                this.handleErrorMessage(response.description);
              }
              //this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage){
                 // Error cart update
                 fetch('/cart')
                  .then(response => response.text())
                  .then(html => {
                  let parser = new DOMParser();
                  let doc = parser.parseFromString(html, 'text/html');
                  let newCartDrawer = doc.querySelector('.cart-drawer');
                  // change 28-07-25
                  // document.querySelector('.cart-drawer').innerHTML = newCartDrawer.innerHTML;
                  //    let cartLink = document.querySelector('#cart-icon-bubble');
                  //   cartLink.dispatchEvent(new Event('click'));
                  });
                 // change 28-07-25
                 $("#CartDrawer").load(location.href+" #CartDrawer>*","");
                 fetch(window.location.pathname + '?sections=cart-icon-bubble')
                    .then(response => response.json())
                    .then(sectionData => {
                      const cartBubble = document.querySelector('[id^="cart-icon-bubble"]');
                      if (cartBubble) {
                        cartBubble.innerHTML = sectionData['cart-icon-bubble'];
                      }
                    });
                // Error cart update

                return;
              } 
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
                //change code 29-07-25 for mobile
              console.log($(window).width());
              if($(window).width() <= "786"){
                const stickyButton = document.getElementById("sticky-cart-button");
                const showMsg = document.querySelector(".show-added-msg");
                var selectedSize = $(".sticky-add-to-cart #gokwik-buy-now").attr("data-size");
                //console.log($("#gokwik-buy-now") +"=="+ selectedSize);
                if (stickyButton) stickyButton.classList.add('hidden');
                if (showMsg) {
                  showMsg.classList.remove("hidden");
                  showMsg.innerHTML = `<span>Size ${selectedSize} added to your bag</span>`;
                  setTimeout(() => {
                    if (stickyButton) stickyButton.classList.remove('hidden');
                    showMsg.classList.add("hidden");
                  }, 2000);

                  $("#CartDrawer").load(location.href+" #CartDrawer>*","");
                 fetch(window.location.pathname + '?sections=cart-icon-bubble')
                    .then(response => response.json())
                    .then(sectionData => {
                      const cartBubble = document.querySelector('[id^="cart-icon-bubble"]');
                      if (cartBubble) {
                        cartBubble.innerHTML = sectionData['cart-icon-bubble'];
                      }
                    });
                }
               //change code 29-07-25 for mobile
              }else{
                CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          console.log(errorMessage+"=="+this.errorMessage)
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
